import React, { lazy } from 'react';
import { SmartphoneIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { CTAButton } from './CTAButton';
const IMG = 'https://cdn.magicpatterns.com/uploads/smZiJdhSvDXY9UfJPq6MV1/cta.webp';
type FinalCTASectionProps = {
  onCTA: () => void;
};
export function FinalCTASection({
  onCTA
}: FinalCTASectionProps) {
  return <section className="relative w-full overflow-hidden" data-id="element-30" data-mp="v3gddbvdr8o">
      <img src={IMG} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover" loading="lazy" data-id="element-31" data-mp="2zea5slna7ff9" />
      <div className="absolute inset-0 bg-tinta/55" aria-hidden="true" data-id="element-32" data-mp="39bojidhtlq3v" />

      <div className="relative mx-auto max-w-3xl px-4 py-24 text-center sm:px-6 sm:py-32" data-id="element-33" data-mp="39adde70wk69l">
        <Reveal data-id="element-34" data-mp="3e3ps9pfs4yp5">
          <h2 className="font-serif text-4xl font-semibold leading-tight text-white sm:text-5xl lg:text-6xl" data-id="element-35" data-mp="3e47x3agicl8o">
            La mujer con energía que fuiste sigue ahí. Solo necesita que le
            abras la puerta.
          </h2>
          <p className="mt-6 text-lg text-white/85" data-id="element-36" data-mp="26vk6hn59i42k">
            Hoy puedes elegir sentirte distinta. Un paso pequeño, un cambio
            real.
          </p>

          <CTAButton onClick={onCTA} icon={SmartphoneIcon} size="lg" className="mt-10" data-id="element-37" data-mp="21y0s8n8kdram">
            Comenzar ahora por USD 8,50
          </CTAButton>

          <p className="mt-6 text-sm uppercase tracking-[0.2em] text-white/75" data-id="element-38" data-mp="1s4a6hq3tnuym">
            Tu cuerpo lleva tiempo pidiéndote esto
          </p>
        </Reveal>
      </div>
    </section>;
}